/* eslint-disable import/no-cycle */
// Utils
import { isObject } from 'ezyvet-fe-helpers';
import { decommitObject } from './decommitObject';
/**
 * For the given value decommit itself(if it's an object) and or any nested objects(object or array)
 * @see decommit
 *
 * @param {any} value
 *
 * @return {any}
 */
export var decommitValue = function (value) {
    if (Array.isArray(value)) {
        return value.map(decommitValue);
    }
    if (isObject(value)) {
        return decommitObject(value);
    }
    return value;
};
//# sourceMappingURL=decommitValue.js.map